import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './Text.module.scss';

const Text = ({
  type = 's',
  children,
  className,
  size = 4,
  weight = 'r',
  ...other
}) => {
  return React.createElement(
    `${type === 's' ? 'span' : 'p'}`,
    {
      className: cn(
        classes.base,
        classes[`text${size}`],
        weight === 'b' ? classes.semibold : '',
        weight === 'm' ? classes.medium : '',
        weight === 'r' ? classes.regular : '',
        className
      ),
      ...other
    },
    children
  );
};

Text.propTypes = {
  size: PropTypes.oneOf([0, 2, 4, 6, 8]),
  type: PropTypes.oneOf(['s', 'p']),
  weight: PropTypes.oneOf(['r', 'm', 'b']),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  className: PropTypes.string
};

export default Text;
